// extracted by mini-css-extract-plugin
export default {"modal":"ModalConfirm_modal__4wlmU","title":"ModalConfirm_title__wSoMk","btnWrapper":"ModalConfirm_btnWrapper__kQ-CK","logoutBtn":"ModalConfirm_logoutBtn__NPYCg"};